import { useQuery } from "@tanstack/react-query";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { workAdvisoryKeys } from "@/lib/query-keys";
import type { FrozenAnalysis, WorkAnalysis } from "@/types/workadvisory";

/** El cruce vigente de una obra para una empresa. `null` si nunca se corrió. */
export function useWorkAnalysis(contractingId: number, organizationId: string) {
  return useQuery({
    queryKey: workAdvisoryKeys.analysis(contractingId, organizationId),
    queryFn: async () => {
      const res = await fetchToBackend<{ data: WorkAnalysis | null }>(
        `/admin/work-advisory/analysis/${contractingId}/${organizationId}`,
      );
      return res.data;
    },
  });
}

/**
 * Corre el cruce. Es una llamada a la IA, así que va a pedido, no en automático.
 * Devuelve además `frozen`: el análisis recortado que se pega en el borrador,
 * para que el cliente lo vea sin regenerar el informe entero.
 */
export function useRunWorkAnalysis() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: {
      contractingId: number;
      organizationId: string;
    }) => {
      const res = await fetchToBackend<{
        data: WorkAnalysis;
        frozen: FrozenAnalysis;
      }>("/admin/work-advisory/analysis", {
        method: "POST",
        body: JSON.stringify(input),
      });
      return res;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: workAdvisoryKeys.all }),
  });
}
